export default {
  autoRenewalMessage: {
    part1:
      '  Your auto-renewal will be turned on for a respective subscription(s). You can manage\n' +
      ' your subscriptions on your customer portal under',
    part2: ' Manage subscription',
    part3: ' section.',
  },
};
